(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./index.less", "../picker", "../_mixins/picker", "../_mixins/basicPicker", "../_mixins/osProps"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./index.less"), require("../picker"), require("../_mixins/picker"), require("../_mixins/basicPicker"), require("../_mixins/osProps"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.index, global.picker, global.picker, global.basicPicker, global.osProps);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _index, _picker, _picker2, _basicPicker, _osProps) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _picker = _interopRequireDefault(_picker);
  _picker2 = _interopRequireDefault(_picker2);
  _basicPicker = _interopRequireDefault(_basicPicker);
  _osProps = _interopRequireDefault(_osProps);
  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        staticClass: "nx-address-picker"
      }, [_c('nx-picker', {
        key: _vm.refreshKey,
        ref: "picker",
        attrs: {
          "value": _vm.value,
          "title": _vm.title,
          "describe": _vm.describe,
          "data": _vm.pickerData,
          "selectedIndex": _vm.selectedIndex,
          "swipeTime": _vm.swipeTime,
          "hasMask": _vm.hasMask,
          "lockScroll": _vm.lockScroll,
          "maskClosable": _vm.maskClosable,
          "position": _vm.position,
          "transition": _vm.transition,
          "okText": _vm.okText,
          "cancelText": _vm.cancelText,
          "slideDownDisappear": _vm.slideDownDisappear,
          "backClosePopup": _vm.backClosePopup,
          "backClosePopupCustomEvent": _vm.backClosePopupCustomEvent,
          "isWebviewFull": _vm.isWebviewFull,
          "blur-material": _vm.blurMaterial
        },
        on: {
          "input": _vm.$_onInput,
          "change": _vm._pickerChange,
          "confirm": _vm._pickerConfirm,
          "cancel": _vm._pickerCancel,
          "show": function show($event) {
            return _vm.$emit('show');
          },
          "hide": function hide($event) {
            return _vm.$emit('hide');
          }
        },
        scopedSlots: _vm._u([_vm.$scopedSlots.default ? {
          key: "default",
          fn: function fn(ref) {
            var pickerData = ref.pickerData;
            return [_vm._t("default", null, {
              "pickerData": pickerData
            })];
          }
        } : null], null, true)
      })], 1);
    },
    name: 'nx-address-picker',
    mixins: [_picker2.default, _basicPicker.default, _osProps.default],
    components: (0, _defineProperty2.default)({}, _picker.default.name, _picker.default),
    data: function data() {
      return {
        pickerData: [],
        addressData: this.data.slice(),
        pickerSelectedIndex: this.selectedIndex.slice(),
        refreshKey: 11,
        ariaAutoFocus: true
      };
    },
    created: function created() {
      this._updatePickerData();

      window.addEventListener('resize', this.resizeOb, false);
    },
    methods: {
      _pickerConfirm: function _pickerConfirm(selectedVal, selectedIndex, selectedText) {
        this.$emit('confirm', selectedVal, selectedIndex, selectedText);
      },
      _pickerCancel: function _pickerCancel() {
        this.$emit('cancel');
      },
      _pickerChange: function _pickerChange(i, newIndex) {
        if (newIndex !== this.pickerSelectedIndex[i]) {
          this.pickerSelectedIndex.splice(i, 1, newIndex);

          this._updatePickerData(i + 1);
        }

        this.$emit('change', i, newIndex);
      },
      _updatePickerData: function _updatePickerData() {
        var _this = this;

        var fromColumn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var data = this.addressData;
        var i = 0;

        while (data) {
          if (i >= fromColumn) {
            (function () {
              var columnData = [];
              data.forEach(function (item) {
                columnData.push({
                  value: item.value,
                  text: item.text,
                  unit: item.unit
                });
              });
              _this.pickerData[i] = columnData;
              /* refillColumn could only be called after show() */

              _this.pickerSelectedIndex[i] = fromColumn === 0 ? _this.pickerSelectedIndex[i] < data.length ? _this.pickerSelectedIndex[i] || 0 : 0 : _this.$refs.picker.refillColumn(i, columnData);
            })();
          }

          data = data.length ? data[this.pickerSelectedIndex[i]].children : null;
          i++;
        }

        if (i < this.pickerData.length) {
          this.pickerData.splice(i, this.pickerData.length - i);
        }
      },
      $_onInput: function $_onInput(val) {
        this.$emit('input', val);
      },
      resizeOb: function resizeOb() {
        this.refreshKey += 'r';
      }
    },
    beforeDestroy: function beforeDestroy() {
      window.removeEventListener('resize', this.resizeOb, false);
    }
  };
  _exports.default = _default;
});